/**
 * Store 专用国际化工具
 * 用于在 Pinia Store 中使用多语言功能
 */
import { useI18n } from 'vue-i18n'

// 获取当前语言的翻译文本
export function getI18nText(key: string, params?: Record<string, any>): string {
  try {
    // 在客户端使用 useI18n
    const { t } = useI18n()
    return params ? t(key, params) : t(key)
  } catch (error) {
    console.warn(`翻译获取失败: ${key}`, error)
    return getDefaultText(key)
  }
}

// 获取默认文本（当翻译不可用时的后备方案）
function getDefaultText(key: string): string {
  const defaultTexts: Record<string, string> = {
    websocket_timeout:
      'WebSocket reply timeout, the message has been sent but not received yet. Please check your network connection or try again later.',
    sse_timeout:
      'SSE reply timeout, the message has been sent but not received yet. Please check your network connection or try again later.',
    network_error: 'Network error, please check your connection',
    send_failed: 'Send failed',
    ai_thinking: 'AI is thinking...',
    request_failed: 'Request failed, please try again later',
    copy_success: 'Copy success',
    delete_success: 'Delete success',
    system_error: 'System error, please try again later',
    connection_failed: 'Connection failed',
    message_send_failed: 'Message send failed, please try again later'
  }

  return defaultTexts[key] || key
}

// 创建响应式的翻译函数（用于 Store 中的 getter）
export function useStoreI18n() {
  return {
    t: getI18nText,
    getDefaultText
  }
}

// 导出常用的错误消息键
export const I18N_KEYS = {
  WEBSOCKET_TIMEOUT: 'websocket_timeout',
  SSE_TIMEOUT: 'sse_timeout',
  NETWORK_ERROR: 'network_error',
  SEND_FAILED: 'send_failed',
  AI_THINKING: 'ai_thinking',
  REQUEST_FAILED: 'request_failed',
  COPY_SUCCESS: 'copy_success',
  DELETE_SUCCESS: 'delete_success',
  SYSTEM_ERROR: 'system_error',
  CONNECTION_FAILED: 'connection_failed',
  MESSAGE_SEND_FAILED: 'message_send_failed'
} as const
